/**
 * @internal Backs `artis.v1.products`: a delta stream over the product catalog with
 * catch-up for late subscribers. The producer seam calls `apply`; consumers subscribe
 * through the `v1.products` surface, not this class.
 *
 * The internal map exists solely to synthesise the catch-up delta on subscribe;
 * callbacks always receive deltas, never full-state snapshots.
 */
const narrowed = (cb, kind) => (delta) => {
    const upserts = delta.upserts?.filter((p) => p.kind === kind);
    const out = {
        ...(upserts?.length ? { upserts } : {}),
        ...(delta.removes?.length ? { removes: delta.removes } : {}),
    };
    if (out.upserts || out.removes)
        cb(out);
};
export class ProductCatalogStore {
    products = new Map();
    subs = new Set();
    apply = (delta) => {
        for (const product of delta.upserts ?? [])
            this.products.set(product.id, product);
        for (const id of delta.removes ?? [])
            this.products.delete(id);
        for (const cb of this.subs)
            cb(delta);
    };
    subscribe = (cb, filters) => {
        const listener = filters?.kind === undefined ? cb : narrowed(cb, filters.kind);
        this.subs.add(listener);
        if (this.products.size > 0)
            listener({ upserts: [...this.products.values()] });
        return () => void this.subs.delete(listener);
    };
}
//# sourceMappingURL=productCatalogStore.js.map